document.querySelectorAll('[data-bos-carousel]').forEach((band) => {
  const track = band.querySelector('[data-bos-track]');
  const prev = band.querySelector('[data-bos-prev]');
  const next = band.querySelector('[data-bos-next]');
  if (!track || !prev || !next) return;

  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    band.classList.toggle('is-static', max < 2);
    prev.disabled = track.scrollLeft < 4;
    next.disabled = track.scrollLeft > max - 4;
  };
  const step = (direction) => {
    const card = track.querySelector('.bos-card');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
  };

  prev.addEventListener('click', () => step(-1));
  next.addEventListener('click', () => step(1));
  track.addEventListener('scroll', update, { passive: true });
  new ResizeObserver(update).observe(track);
  update();
});
